import { render, staticRenderFns } from "./seasons-list.component.vue?vue&type=template&id=064ecbbe&scoped=true&"
import script from "./seasons-list.component.vue?vue&type=script&lang=ts&"
export * from "./seasons-list.component.vue?vue&type=script&lang=ts&"
import style0 from "./seasons-list.component.vue?vue&type=style&index=0&id=064ecbbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064ecbbe",
  null
  
)

export default component.exports